// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1mwwl","errorLogs":"EditorFooter_errorLogs__lLP5R"};